export enum PowerState {
  NORMAL = 'NORMAL',
  STANDBY = 'STANDBY',
}
